import * as React from "react";
import {WithApi, WithApiProperties} from "../../common/util/WithApi";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {Role} from "../../user/model";
import {Logger} from "../../common/util/Logger";
import {Button, ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import {ModalMessageDialog, ModalMessageDialogMode} from "../commons/ModalMessageDialog";

const ROLES_DATA_LIST_ROW_HEIGHT = 50;

interface State {
  role: string;
  description: string;
  modalDialog: JSX.Element[];
}

class RoleDetailsPageComponent extends React.Component<WithApiProperties & InjectedIntlProps, State> {
  _logger: Logger = Logger.getLogger("settings.roles-page");

  constructor(props) {
    super(props);
    this.state = {
      role: (this.props as any).match.params.role,
      description: "",
      modalDialog: []
    }
  }

  componentDidMount() {
    const role: Role = {
      role: this.state.role
    }
    this.props.api.getRole(role).then((r) => {
      this.setState({
            description: r.description
      })
        },
        (e) => {
          this._logger.error("Error occurred while retrieving role.", e);
        })
  }

  private handleChange = (event: any) => {
    event.preventDefault();
    const {name, value} = event.target;
    // @ts-ignore
    this.setState({
      [name]: value
    })
  }

  private closeModal = () => {
    this.setState({modalDialog: []})
  }

  private openModal = (modal: JSX.Element) => {
    this.setState({modalDialog: [modal]})
  }
  private submit = (event:any) => {
    event.stopPropagation();
    event.preventDefault();

    const {intl} = this.props;
    const role: Role = {
      role: this.state.role,
      description: this.state.description
    }
    this.props.api.updateRole(role).then((_) => {
          this.openModal(<ModalMessageDialog
              key="update-success"
              onClose={this.closeModal}
              mode={ModalMessageDialogMode.SUCCESS}
              body={intl.formatMessage({
                id: "studio.products.role-management.role-details.update-success",
                defaultMessage: "Role successfully updated."
              })}
          />);
        },
        (e) => {
          this._logger.error("Error occurred while updating role.", e);
          this.openModal(<ModalMessageDialog
              key="update-error"
              onClose={this.closeModal}
              mode={ModalMessageDialogMode.ERROR}
              body={intl.formatMessage({
                id: "studio.products.role-management.role-details.update-error",
                defaultMessage: "Failed to update role."
              })}
          />);
        })
  }

  render() {
    const {intl} = this.props;

    return (
        <form onSubmit={this.submit}>
          <h1>
            <FormattedMessage id="studio.users.role-details.title"
                              defaultMessage="Modify Role"/>
          </h1>
          <hr/>
          <FormGroup controlId="group-rolename-id">
            <ControlLabel>
              <FormattedMessage id="studio.users.role-details.label-rolename"
                                defaultMessage="Role name:"
              />
            </ControlLabel>
            <FormControl autoFocus type="text" name="role" value={this.state.role} readOnly={true}/>
          </FormGroup>
          <FormGroup controlId="group-role-description-id">
            <ControlLabel>
              <FormattedMessage id="studio.users.role-details.label-description"
                                defaultMessage="Description:"
              />
            </ControlLabel>
            <FormControl type="text" name="description" value={this.state.description}
                         onChange={this.handleChange} required={true}/>
          </FormGroup>
          <div>
            <LinkContainer to="/settings/roles">
              <Button>
                <FormattedMessage
                    id="studio.users.role-details.button.close"
                    defaultMessage="Back"
                />
              </Button>
            </LinkContainer>
            <Button type="submit" style={{marginLeft:10}}>
              <FormattedMessage
                  id="studio.users.role-details.button.ok"
                  defaultMessage="Update"
              />
            </Button>
          </div>
          {this.state.modalDialog}
        </form>
    );
  }

}

export const RoleDetailsPage = injectIntl(WithApi(RoleDetailsPageComponent));
